import { axiosInstance } from "./axios";

export const sendPartnerEnquiry = (data) => {
  return axiosInstance.post("/enquiry/", data);
};
